import React from "react";

function ListMoreIcon() {
  return (
    <span className="anticon anticon-listmore">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 21 6"
      >
        <g fill="currentColor" fillRule="evenodd" transform="translate(.306 .038)">
          <circle cx="2.5" cy="2.5" r="2.5"></circle>
          <circle cx="10.5" cy="2.5" r="2.5"></circle>
          <circle cx="17.5" cy="2.5" r="2.5"></circle>
        </g>
      </svg>
    </span>
  );
}

export default ListMoreIcon;
